<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="chapter-number---IVP sigil_not_in_toc"><span epub:type="pagebreak" id="pagevii" title="vii"></span></h1>
<h2 class="chapter-title---IVP" id="_idParaDest-2"><a id="_idTextAnchor001"></a>Contents</h2>
<div>
<div epub:type="toc" id="_idContainer006">
<p class="veryfirst"><a href="#/Text/07_prelude#_idTextAnchor004">A Necessary Prelude	</a></p>
<p class="firstleft"><a href="#/Text/08_part1#_idTextAnchor007"><span class="sans">PART I. THE STRUGGLE</span></a></p>
<blockquote>
<p class="left"><a href="#/Text/09_ch1#_idTextAnchor012">1 Hard Thoughts About God</a></p>
<p class="first"><a href="#/Text/10_ch2#_idTextAnchor060">2 Don’t Answer Why</a></p>
<p class="first"><a href="#/Text/11_ch3#_idTextAnchor110">3 Longing and Lament</a></p>
<p class="first"><span href="#/Text/12_ch4#_idTextAnchor228" title="Link target outside of Sample">4 Embracing Our Embodiment</span></p>
<p class="first"><span href="#/Text/13_ch5#_idTextAnchor379" title="Link target outside of Sample">5 Questions That Come with Pain</span></p>
</blockquote>
<p class="firstleft"><span href="#/Text/14_part2#_idTextAnchor464" title="Link target outside of Sample"><span class="sans">PART II. THE STRANGENESS OF GOD</span></span></p>
<blockquote>
<p class="left"><span href="#/Text/15_ch6#_idTextAnchor471" title="Link target outside of Sample">6 One with Us: Incarnation</span></p>
<p class="first"><span href="#/Text/16_ch7#_idTextAnchor643" title="Link target outside of Sample">7 One for Us: Cross</span></p>
<p class="first"><span href="#/Text/17_ch8#_idTextAnchor826" title="Link target outside of Sample">8 Risen and Remaining</span></p>
</blockquote>
<p class="firstleft"><span href="#/Text/18_part3#_idTextAnchor1072" title="Link target outside of Sample"><span class="sans">PART III. LIFE TOGETHER</span></span></p>
<blockquote>
<p class="left"><span href="#/Text/19_ch9#_idTextAnchor1077" title="Link target outside of Sample">9 Faith, Hope, and Love</span></p>
<p class="first"><span href="#/Text/20_ch10#_idTextAnchor1232" title="Link target outside of Sample">10 Confession and the Other</span></p>
<p class="first"><span href="#/Text/21_ch11#_idTextAnchor1383" title="Link target outside of Sample">11 Faithful</span></p>
</blockquote>
<p class="firstleft"><span href="#/Text/22_acknowledgments#_idParaDest-19" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="first"><span href="#/Text/23_notes#_idTextAnchor1507" title="Link target outside of Sample">Notes</span></p>
<p class="first"><span href="#/Text/24_general_index#_idTextAnchor1952" title="Link target outside of Sample">General Index</span></p>
<p class="first"><span href="#/Text/25_scripture_index#_idTextAnchor1954" title="Link target outside of Sample">Scripture Index	</span></p>
<p class="first"><span href="#/Text/26_praise#_idTextAnchor1956" title="Link target outside of Sample">Praise for <i>Embodied Hope</i></span></p>
<p class="first"><span href="#/Text/27_author#_idTextAnchor1957" title="Link target outside of Sample">About the Author</span></p>
<p class="first"><span href="#/Text/28_moreIVP#_idTextAnchor1958" title="Link target outside of Sample">More Titles from InterVarsity Press</span><br/><br/></p>
<p class="firstleft"><span href="#/Text/29_study_guide#_idTextAnchor1960" title="Link target outside of Sample"><span class="sans">EMBODIED HOPE STUDY GUIDE</span></span></p>
<blockquote>
<p class="left"><span href="#/Text/29_study_guide#_idParaDest-28" title="Link target outside of Sample">Part I. The Struggle</span></p>
<p class="body"><span href="#/Text/29_study_guide#_idTextAnchor1963" title="Link target outside of Sample"><i>Chapter 1: Hard Thoughts About God</i></span></p>
<p class="body"><span href="#/Text/29_study_guide#_idTextAnchor1964" title="Link target outside of Sample"><i>Chapter 2: Don’t Answer Why</i></span></p>
<p class="body"><span href="#/Text/29_study_guide#_idTextAnchor1965" title="Link target outside of Sample"><i>Chapter 3: Longing and Lament	</i></span></p>
<p class="body"><span href="#/Text/29_study_guide#_idTextAnchor1968" title="Link target outside of Sample"><i>Chapter 4: Embracing Our Embodiment</i></span></p>
<p class="body"><span href="#/Text/29_study_guide#_idTextAnchor1970" title="Link target outside of Sample"><i>Chapter 5: Questions That Come with Pain</i></span></p>
<p class="first"><span href="#/Text/29_study_guide#_idTextAnchor1972" title="Link target outside of Sample">Part II. The Strangeness of God</span></p>
<p class="body"><span href="#/Text/29_study_guide#_idTextAnchor1973" title="Link target outside of Sample"><i>Chapter 6: One with Us</i></span></p>
<p class="body"><span href="#/Text/29_study_guide#_idTextAnchor1974" title="Link target outside of Sample"><i>Chapter 7: One for Us</i></span></p>
<p class="body"><span href="#/Text/29_study_guide#_idTextAnchor1976" title="Link target outside of Sample"><i>Chapter 8: Risen and Remaining</i></span></p>
<p class="first"><span href="#/Text/29_study_guide#_idTextAnchor1978" title="Link target outside of Sample">Part III. Life Together</span></p>
<p class="body"><span href="#/Text/29_study_guide#_idTextAnchor1979" title="Link target outside of Sample"><i>Chapter 9: Faith, Hope, and Love</i></span></p>
<p class="body"><span href="#/Text/29_study_guide#_idTextAnchor1981" title="Link target outside of Sample"><i>Chapter 10: Confession and the Other</i></span></p>
<p class="body"><span href="#/Text/29_study_guide#_idTextAnchor1983" title="Link target outside of Sample"><i>Chapter 11: Faithful</i></span></p>
<p class="body"><span href="#/Text/29_study_guide#_idTextAnchor1985" title="Link target outside of Sample"><i>Outlines</i></span></p>
<p class="body"><span href="#/Text/29_study_guide#_idTextAnchor1986" title="Link target outside of Sample"><i>Notes</i></span></p>
</blockquote>
<p class="first"><span href="#/Text/03_copyright" title="Link target outside of Sample">Copyright</span><br/><br/></p>
</div>
</div>
<p class="body"><span epub:type="pagebreak" id="pageviii" title="viii"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_contents.vue?2e785126